import { useEffect, useState } from 'react';

const SCAN_LAUNCH_LOADING_MESSAGES = [
  'selecting models.',
  'examining codebase.',
  'routing security skills.',
  'preparing scan run.'
];

const SCAN_LAUNCH_LOADING_LOGOS = [
  { name: 'Trail of Bits', src: '/trail_of_bits_logo.jpg' },
  { name: 'Cyfrin', src: '/cyfrin.jpg' },
  { name: 'Pashov', src: '/pashovlogo.png' },
  { name: 'QuillShield', src: '/quillshield.avif' },
  { name: 'SC Audit Studio', src: '/scauditstudiologo.png' }
];

function ScanLaunchLoading() {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setMessageIndex((currentIndex) => (currentIndex + 1) % SCAN_LAUNCH_LOADING_MESSAGES.length);
    }, 1800);

    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <aside className="scan-launch-loading" role="status" aria-live="polite" aria-atomic="true">
      <div className="scan-launch-logo-stage" aria-hidden="true">
        {SCAN_LAUNCH_LOADING_LOGOS.map((logo, index) => (
          <span
            className="scan-launch-logo-motion"
            key={logo.name}
            style={{ animationDelay: `${index * -1.6}s` }}
          >
            <img src={logo.src} alt="" />
          </span>
        ))}
      </div>

      <p className="scan-launch-loading-text">{SCAN_LAUNCH_LOADING_MESSAGES[messageIndex]}</p>
    </aside>
  );
}

export default ScanLaunchLoading;
